import * as React from 'react'

import {
    useMediaQuery,
} from '@mui/material'

import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';


import LogoIcon from '../../../assets/images/Logos/BHBUSMidia.png';
import { AddressDiv, BaseDiv, ContactDiv, ContentDiv, CopyRight, IconsDiv, LeftSide, Logo, PrincipalDiv } from './styles';

interface INavBar {

}



const Footer: React.FC<INavBar> = () => {
    const matches = useMediaQuery('(max-width:800px)');
    const Whatsap = 'https://api.whatsapp.com/send/?phone=5531982213102&text&type=phone_number&app_absent=0';
    const Linkedin = 'https://br.linkedin.com/company/gomidiabh';
    const Instagram = 'https://www.instagram.com/bhbusmidia/';

    const handleWhatsAppClick = () => {
        const url = `${Whatsap}`;
        window.open(url, '_blank');
    };

    const handleLinkedinClick = () => {
        const url = `${Linkedin}`;
        window.open(url, '_blank');
    };

    const handleInstagramClick = () => {
        const url = `${Instagram}`;
        window.open(url, '_blank');
    };

    return (
        <PrincipalDiv>
            <BaseDiv>
                <ContentDiv>
                    {!matches ? (
                        <>
                            <LeftSide>
                                <Logo src={LogoIcon}/>
                                <AddressDiv>
                                    <h1>Endereço</h1>
                                    <p>R. Aquiles Lobo, 504 - 9° andar</p>
                                    <p>Floresta, Belo Horizonte - MG</p>
                                </AddressDiv>
                            </LeftSide>
                            <ContactDiv>
                                <h1>Contato</h1>
                                <p>Whatsapp:(31) 98221 3102</p>
                                <p>Comercial:(31) 3248 7095</p>
                                <p>contato@gomidiabh.com.br</p>
                                <IconsDiv>
                                    <InstagramIcon sx={{ width: "1.5em", height: "1.5em", cursor: "pointer" }} onClick={handleInstagramClick}/>
                                    <LinkedInIcon sx={{ width: "1.5em", height: "1.5em", cursor: "pointer" }}  onClick={handleLinkedinClick}/>
                                    <WhatsAppIcon sx={{ width: "1.5em", height: "1.5em", cursor: "pointer" }}  onClick={handleWhatsAppClick}/>
                                </IconsDiv>
                            </ContactDiv>
                        </>
                    ) : (
                        <>
                            <Logo src={LogoIcon} height="50px"/>
                                <LeftSide>
                                    
                                    <AddressDiv>
                                        <h1>Endereço</h1>
                                        <p>R. Aquiles Lobo, 504 - 9° andar</p>
                                        <p>Floresta, Belo Horizonte - MG</p>
                                    </AddressDiv>
                                </LeftSide>
                                <ContactDiv>
                                    <h1>Contato</h1>
                                    <p>Whatsapp: (31) 98221 3102</p>
                                    <p>Comercial: (31) 3248 7095</p>
                                    <p>contato@gomidiabh.com.br</p>
                                    <IconsDiv>
                                        <InstagramIcon sx={{ cursor: "pointer" }} onClick={handleInstagramClick} className='icons'/>
                                        <LinkedInIcon sx={{ cursor: "pointer" }}  onClick={handleLinkedinClick} className='icons'/>
                                        <WhatsAppIcon sx={{ cursor: "pointer" }}  onClick={handleWhatsAppClick} className='icons'/>
                                    </IconsDiv>
                                </ContactDiv>
                        </>
                    )}
                </ContentDiv>
            </BaseDiv>
            <CopyRight>
                <p>© 2024 - Desenvolvido por <strong>BHBUS Mídia</strong></p>
                <p>Todas as marcas registradas e direitos autorais pertencem aos seus respectivos proprietários</p>
            </CopyRight>
        </PrincipalDiv>

    );
}

export { Footer }